import '/assets/sass/styles.scss';
import '/assets/sass/zoo-styles.scss';


window.ZOOAMERICA =  {};

var $maps = null;
var gMapsKey = 'AIzaSyC87KIbQM9seoRRVOiQtO0FXdUt9i8kPDA';
var maps = [];

$(function(){
    
    // Add rel="noopener" to any links that need it
    $('a').each(function(i,a){
        var target = $(a).attr('target');
        
        if(target === '_blank') {
            $(a).attr('rel', 'noopener');
        }
    });
    
    // Set focus on skip link click
    $('.skip-link').on('click', function(){
        var skipTo = $("#"+this.href.split('#')[1]);
        skipTo.attr('tabindex', '0');
        skipTo.focus();
    });
    
    // Animals search page - Load More
    $('#animals #load-more').on('click', function(){
        $('.animal-card.hide').each(function(i, card){
            $(card).velocity('transition.swoopIn', {
                duration: 600,
                delay: i*100,
                complete: function(){
                    $(this).removeClass('hide');
                    if(!$('.animal-card.hide').length) {
                        $('#load-more').fadeOut();
                    }
                    $('#results num').html(parseInt($('#results num').html())+1);
                }
            });
            
            if(i >= 5) {
                return false;
            }
        });
        
        return false;
    });
    
    $('form#animal-filter-form').on('submit', function(){
        ajaxHandleAnimalSearch(this);
        return false;
    });

	$('#mbl-menu-open,#mbl-menu-close').on('click', function(e){
		e.preventDefault();
		$('#mbl-menu').toggleClass('opened');
	});

	var d = new Date();
	var currentcntr = 0;
		modifyKey();
	//$("#calendars-holder").css({"margin-left":"-"+(currentmonth*100)+"%"});
	$("#calendar-thumbs .calendar").on('click', function(){
        var counter = parseInt($(this).data('counter'));
		let distance = ( Math.abs(currentcntr-(counter)) );
		let speed = ( 500+((distance/2)*100) );
//console.log(speed);
		currentcntr = (counter);
		$("#calendars-holder").animate({"margin-left":"-"+(currentcntr*100)+"%"}, speed);
		modifyKey();
		$('html, body').animate({ scrollTop: $("#calendar-full").offset().top },750);
	});
	function modifyKey(){
		$("#calendar-key>li").hide();
		$("#calendars-holder").children().eq(currentcntr).find( $("[class^=hrs_]") ).each(function() {
			$("#calendar-key").find($("."+this.className)).parent().show();
		});
	}

    // ADA fix for owl carousels
    $('.owl-carousel').on('keydown', function(e){
        var owl = $(this);

        switch(e.keyCode) {
            case 37: // left arrow
                owl.trigger('owl.prev');
                return false;
            case 39: // right arrow
                owl.trigger('owl.next');
                return false;
        }
    });

	$('#toggle-view').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass("list");
		$("#calendar-view,#list-view").toggle();
	});
	
	$('#map-enlarge').on('click', function(e){
		e.preventDefault();
		$('body').append('<a id="map-close" href="#map-close" title="close enlarged map"><svg focusable="false" role="presentation"><use xlink:href="/assets/images/icons.svg#close-x" /></svg></a><img id="map-enlarged" src="/assets/images/visitor-info/map.svg" alt="ZooAmerica map" />');
	});
	$('body').on('click', '#map-close', function(e) {
		$(this).remove();
		$('#map-enlarged').remove();
		return false;
	});

	/*
	 * *************************
	 * HASH
	 * *************************
	*/
    setTimeout(function() {
      if (location.hash) {
        window.scrollTo(0, 0);
        target = location.hash.split('#');
        smoothScrollTo($('#'+target[1]));
        $('#'+target[1]).trigger('click');
      }
    }, 1);

    // Was throwing a console error, unrecognized expression
//    $('a[href*=#]:not([href=#])').click(function() {
//      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//        smoothScrollTo($(this.hash));
//        return false;
//      }
//    });
  
  function smoothScrollTo(target) {
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    
    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top
      }, 1000);
    }
  }




	/*
	 * *************************
	 * MODULE - GOOGLE MAPS
	 * *************************
	*/
    $maps = $('.gmap');
	if ($maps.length && gMapsKey) {
        // LOAD GOOGLE MAPS API
        $('.map-overlay').on('click', function(){
            var script = document.createElement('script');
                script.src = '//maps.googleapis.com/maps/api/js?key=' + gMapsKey + '&v=3.exp&callback=ZOOAMERICA.GMAPS.init';
            document.body.appendChild(script);
			document.getElementsByClassName('map-overlay').style.visibility='hidden';
        });
	}


    $('.w33 .orng-afterwards img').on('click', function () {
        var clicks = $(this).data('clicks');
        if (typeof clicks === 'undefined') {
            clicks = 1;
        }
        else {
            clicks++;
        }

        if (clicks >= 5) {
            $(this).replaceWith('<div class="otter"><img src="/assets/images/otter.webp" alt="Cute Baby Otter"/></div>')
            clicks = 0;
        }
        
        $(this).data('clicks', clicks);
    });  
});

window.ZOOAMERICA.GMAPS = {
    maps: [],
    init: function () {
        // DEFINE MAP STYLES
        var styles = [
            {
                "elementType":"geometry",
                "stylers": [{
                    "color":"#e9f4e7"
                }]
            },
            {
                "elementType":"labels.text.fill",
                "stylers": [{
                    "color":"#254c5a"
                }]
            },
            {
                "elementType":"labels.text.stroke",
                "stylers": [{
                    "color":"#ffffff"
                }]
            },
            {
                "featureType":"poi",
                "elementType":"geometry",
                "stylers": [{
                    "color":"#bbdfb8"
                }]
            },
            /*{
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                {
                    "color": "#00ff00"
                }]
            },*/
            {
                "featureType":"road",
                "elementType":"geometry",
                "stylers": [{
                    "color":"#d5d1ce"
                }]
            },
            {
                "featureType":"water",
                "elementType":"geometry",
                "stylers": [{
                    "color":"#4e748b"
                },{
                    "saturation":-10
                },{
                    "lightness":20
                }]
            },
            {
                "featureType":"water",
                "elementType":"labels",
                "stylers": [{
                    "visibility":"off"
                }]
            }
        ];

        // LOOP THROUGH ALL GOOGLE MAP STATIC IMAGES, REPLACE WITH INTERACTIVE MAP
        $maps.each(function (i) {
            var $map = $(this);
            var id ='gmaps-' + i;
            var gmap;
            var glatlng;
			var gmarker;

            // REPLACE STATIC IMAGE WITH INTERACTIVE MAP
            $map.parent().html('<div id="' + id + '" style="height:100%;"></div>');

            // CREATE INTERACTIVE MAP
            glatlng = new google.maps.LatLng(Number($map.attr('data-lat')), Number($map.attr('data-lng')));

            gmap = new google.maps.Map(document.getElementById(id), {
				mapTypeControl:false,
				streetViewControl:false,
                zoom: Number($map.attr('data-zoom')),
                center: glatlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: styles
            });
            
			// ADD MAP MARKER
			gmarker = new google.maps.Marker({
				position: glatlng,
				animation: google.maps.Animation.DROP,
				map: gmap,
				icon: '/assets/images/icon/paw.png',
				title: $map.attr('data-title')
			});

			// ADD MAP MARKER CLICK EVENT
			google.maps.event.addListener(gmarker, 'click', function () {
				infoWindow.open(gmap,gmarker);
			});
                        
            /*
             * do something only the first time the map is loaded
             * - ADA shims for gmaps for AMP
             */ 
            google.maps.event.addListenerOnce(gmap, 'idle', function(){
                // Perform ADA fixes to the map
                $('#'+id+' img').each(function(i, img){
                    if(typeof($(img).attr('alt')) === 'undefined') {
                        $(img).attr('alt', 'Google Maps image');
                    }
                });
                
                $('#'+id+' a[target=_blank]').each(function(i, atb){
                    var title = $(atb).attr('title');
                    if(typeof(title) === 'undefined' || title == '') {
                        $(atb).attr('title', 'Google Maps external link');
                    }
                });
            });

            // ADD MAP TO OBJECT MAPS ARRAY
            window.ZOOAMERICA.GMAPS.maps.push(gmap);
        });
    }
};





function ajaxHandleAnimalSearch(form) {
    BlockUI.Show($(form));
    
    var data = $(form).serialize();
    history.replaceState(data, 'search', window.location.pathname+'?'+data);
    
    data += '&action=animal_search';
    
    $.ajax({
        url: encodeURI('/assets/ajax/form-handler.php'),
        type: 'POST',
        data: data,
        dataType: "json",
        success: function (r) { 
            if(typeof(r.success) === 'undefined') {
                console.log('Server error. Please contact technical support with reference: AJAX ERROR.');
                setTimeout(function(){
                    BlockUI.Hide();
                },500);
            }
            else if(!r.success) {
                console.log(r);
                setTimeout(function(){
                    BlockUI.Hide();
                },500);
            }
            else {
                // Success
                if($('.animal-card').length) {
                    $('.animal-card').velocity('transition.slideUpOut', {
                        duration: 300,
                        stagger: 50,
                        complete: function() {
                            $(this).remove();
                            loadAnimalCards(r.data);
                        }
                    });
                }
                else {
                    loadAnimalCards(r.data);
                }
                $('p#results ').html(r.data.message);
                
                if(r.data.count > 6) {
                    $('#load-more').fadeIn();
                }
                else {
                    $('#load-more').fadeOut();
                }
            }
        },
        error: function (error) { 
            //handleAjaxError(form, error);
        }
    });
    
    // Send to GTM
    if(typeof(dataLayer) !== 'undefined') {
        dataLayer.push({
            'event': 'Animal Search',
            'ajax_form_status': 'search'
        });
    }
}


function loadAnimalCards(data) {
    $.each(data.animals, function(i, animalCard){
        $('#animals #card-container').append(animalCard);
    });

    $('.animal-card').each(function(i, card){
        $(card).velocity('transition.swoopIn', {
            duration: 600,
            delay: i*100,
            complete: function(){
                $(this).removeClass('hide');
            }
        });

        if(i >= 5) {
            return false;
        }
    });
    
    setTimeout(function(){
        BlockUI.Hide();
    },500);
}


var BlockUI = {
    
    Show: function(el, text) {
        if(typeof(text) === 'undefined') {
            text = 'Please wait...';
        }
        var b = '';
        
        b += '<div class="ui-blocker">';
        
        var tag = $(el)[0].tagName;
        if(tag == 'FORM') {
            b += '<img src="https://misc.hersheypa.com/assets/cdn/images/loading-kiss.gif" alt="Loading..."/>';
        }
        else {
            b += '<span class="block-text">'+text+'</span>';
        }
        b += '</div>';
        
        $(el).addClass('ui-blocked').append(b);
    },
    
    Hide: function() {
        $('.ui-blocked').removeClass('ui-blocked').find('.ui-blocker').remove();
    }
};


function onloadCallback() {
    $('#g-recaptcha-response').attr('aria-hidden', true);
    $('#g-recaptcha-response').attr('aria-label', 'do not use');
    $('#g-recaptcha-response').attr('aria-readonly', true);
}